import { BoardManager } from "../BoardManager";
import { ContractStatusPanel } from "./ContractStatusPanel";
import { BotErrorPanel } from "./BotErrorPanel";
import { HandsCounter } from "./HandsCounter";

export class HUD extends Phaser.GameObjects.Container {

    private readonly contractStatusPanel: ContractStatusPanel;
    private readonly botErrorPanel: BotErrorPanel;
    private readonly handsCounter: HandsCounter;

    constructor(scene: Phaser.Scene, boardManager: BoardManager) {

        super(scene);

        this.handsCounter = new HandsCounter(scene);
        this.contractStatusPanel = new ContractStatusPanel(scene, boardManager);
        this.botErrorPanel = new BotErrorPanel(scene, boardManager);
        this.add([this.handsCounter, this.contractStatusPanel, this.botErrorPanel]);
    }

    public relayout(): void {

        this.handsCounter.relayout();
        this.contractStatusPanel.relayout();
        this.botErrorPanel.relayout();
    }

    public startPlayLayoutTransition(): void {

        this.handsCounter.startPlayLayoutTransition();
    }
}
